module.exports = __webpack_public_path__ + "img/71ee4413ebb7786b2a8654d4dd36f017.b106235d.jpg";